/**
 * @generated SignedSource<<826d64dd4a942523f6b09640fe9a1048>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GivePointsToAllParticipantsInput = {
  clientMutationId?: string | null;
  countToSelect?: number | null;
  excludeIds?: ReadonlyArray<string | null> | null;
  excludeNonTest?: boolean | null;
  expectedCostUsdCents: number;
  filterComplex?: any | null;
  includeTest?: boolean | null;
  points: number;
  studyId: string;
  tab?: string | null;
};
export type GivePointsMutations_givePointsToAllParticipants_Mutation$variables = {
  input: GivePointsToAllParticipantsInput;
};
export type GivePointsMutations_givePointsToAllParticipants_Mutation$data = {
  readonly givePointsToAllParticipants: {
    readonly study: {
      readonly participants: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly bonusPoints: ReadonlyArray<{
              readonly orderDate: any;
              readonly pointsAmount: number;
            } | null>;
          } | null;
        } | null>;
      } | null;
    };
    readonly summary: {
      readonly feesUsdCents: number;
      readonly nonTestParticipantCount: number;
      readonly pointsCostUsdCents: number;
      readonly testParticipantCount: number;
    };
  } | null;
};
export type GivePointsMutations_givePointsToAllParticipants_Mutation = {
  response: GivePointsMutations_givePointsToAllParticipants_Mutation$data;
  variables: GivePointsMutations_givePointsToAllParticipants_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "GivePointsCostsSummary",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pointsCostUsdCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feesUsdCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "testParticipantCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nonTestParticipantCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipantBonusPointsNode",
  "kind": "LinkedField",
  "name": "bonusPoints",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pointsAmount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GivePointsMutations_givePointsToAllParticipants_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GivePointsToAllParticipantsPayload",
        "kind": "LinkedField",
        "name": "givePointsToAllParticipants",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipantNodeConnection",
                "kind": "LinkedField",
                "name": "participants",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipantNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParticipantNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GivePointsMutations_givePointsToAllParticipants_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GivePointsToAllParticipantsPayload",
        "kind": "LinkedField",
        "name": "givePointsToAllParticipants",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipantNodeConnection",
                "kind": "LinkedField",
                "name": "participants",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipantNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParticipantNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "623ad898ef5f2046ee1fe0438a806a68",
    "id": null,
    "metadata": {},
    "name": "GivePointsMutations_givePointsToAllParticipants_Mutation",
    "operationKind": "mutation",
    "text": "mutation GivePointsMutations_givePointsToAllParticipants_Mutation(\n  $input: GivePointsToAllParticipantsInput!\n) {\n  givePointsToAllParticipants(input: $input) {\n    summary {\n      pointsCostUsdCents\n      feesUsdCents\n      testParticipantCount\n      nonTestParticipantCount\n    }\n    study {\n      participants {\n        edges {\n          node {\n            bonusPoints {\n              orderDate\n              pointsAmount\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef774917f5f2697c222e0d88b4975dab";

export default node;
